(function (ng) {
    ng.module('evo.Compare.Filters').filter('numeralCurrency', function () {
        return function (price) {
            return numeral(price).format();
        };
    });
})(angular);